module.exports = __webpack_public_path__ + "img/EffectOneIn.a9f18f3e.png";